import React from 'react';
import { ProjectPhaseMap } from 'api/project';
import { StatusGroup } from 'api/tasks';
import { ReactComponent as Phase } from 'assets/svgs/phase.svg';

export const PhaseProgress = ({
  phaseData,
}: {
  phaseData: ProjectPhaseMap[];
}) => {
  return (
    <>
      {phaseData.map((phase) => {
        let fill: string;

        switch (phase.status.group) {
          case StatusGroup.InProgress:
            fill = 'var(--green-30)';
            break;
          case StatusGroup.Completed:
            fill = 'var(--green-50)';
            break;
          case StatusGroup.Blocked:
            fill = 'var(--red-60)';
            break;
          default:
            fill = 'var(--coolest-gray-40)';
        }

        return <Phase key={phase.id} fill={fill} />;
      })}
    </>
  );
};
